import { Autocomplete, TextField } from '@mui/material'
import { useLoading } from '../hooks/useLoading'
import type { ProviderManagement } from '../types'
import { ActionProgress } from './ActionProgress'

interface Props {
  labelSuffix?: 'From' | 'To'
  options: ProviderManagement[]
  value: ProviderManagement | null
  onChange: (value: ProviderManagement | null) => void
}

export const ProvidersAutocomplete = (props: Props) => {
  const { labelSuffix, options, value, onChange } = props
  const { providersLoading, loading } = useLoading()
  const label = providersLoading ? (
    <ActionProgress label="Retrieving Providers" />
  ) : labelSuffix ? (
    `Provider ${labelSuffix}`
  ) : (
    'Provider'
  )

  return (
    <Autocomplete
      options={options}
      value={value}
      disabled={loading}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={(option) => option.displayName}
      isOptionEqualToValue={(option, val) => option.cwsId === val.cwsId}
      noOptionsText="No providers"
      renderInput={(params) => (
        <TextField {...params} label={label} sx={{ width: 420 }} />
      )}
    />
  )
}
